<ng-container *ngIf="overlay; else progressSpinner">
<div class="overlay">
    <div class="center">
        <ng-template [ngTemplateOutlet]="progressSpinner"></ng-template>
    </div>
</div>
</ng-container>
<ng-template #progressSpinner>
    <mat-spinner></mat-spinner>
</ng-template>